// extracted by mini-css-extract-plugin
export default {"avatar":"FallbackAvatar_avatar__c9j7L"};